// Global Klaviyo tracking functions
window.handleBuyNowClick = function(button) {
  var productData;
  
  // Extract product data from data attribute
  var productDataString = button.getAttribute('data-product');
  if (productDataString) {
    try {
      productData = JSON.parse(productDataString);
    } catch (e) {
      productData = null;
    }
  }
  
  if (!productData) {
    return;
  }
  
  trackExternalBuyNow(productData);
};

window.trackExternalBuyNow = function(productData) {
  if (typeof klaviyo !== 'undefined' && klaviyo.track) {
    try {
      var eventData = {
        "Name": productData.name || "",
        "ProductID": productData.productId || "",
        "ExternalURL": productData.externalUrl || "",
        "Categories": productData.categories || [],
        "Brand": productData.brand || "",
        "ImageURL": productData.imageUrl || "",
        "CompareAtPrice": productData.compareAtPrice || "0.00",
        "URL": productData.url || "",
        "Price": productData.price || "",
        "Value": productData.value || "",
        "Timestamp": new Date().toISOString()
      };
      
      klaviyo.track("External Buy Button Clicked", eventData);
    } catch (e) {
      // Silently fail - tracking shouldn't break user experience
    }
  }
};
